import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Modal,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import MetaTags from "react-meta-tags";
import * as mode from "../../../routes/PageMode";
import { C_Select } from "../../../CustomValidateForm";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import {
  metaTagLabel,
  breadcrumbReturnFunc,
} from "../../../components/Common/CommonFunction";
import * as _cfunc from "../../../components/Common/CommonFunction";
import {
  initialFiledFunc,
  comAddPageFieldFunc,
} from "../../../components/Common/validationFunction";
import * as _act from "../../../store/actions";
import { url, pageId } from "../../../routes/index";
import {
  downloadNocDocument,
  uploadNocDocument,
  uploadNocDocumentSuccess,
  filterNocDocument,
} from "../../../store/Administrator/UploadNocRedux/action";
import Slidewithcaption from "../../../components/Common/CommonImageComponent";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PDF_ReturnReport } from "./PDF";
import {
  commonPageField,
  commonPageFieldSuccess,
} from "../../../store/actions";

const NocDocumentUpload = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [userPageAccessState, setUserAccState] = useState("");
  const [Return_Pdf_loading, setReturn_Pdf_loading] = useState(false);
  const fileInputRef = useRef(null);
  const [isShowClicked, setIsShowClicked] = useState(false);
  const [fileAlreadyUploaded, setFileAlreadyUploaded] = useState(false);
  const [fileInputDisabled, setFileInputDisabled] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [hoveredBtn, setHoveredBtn] = useState("");
  const location = { ...history.location };
  const hasShowModal = props.hasOwnProperty(mode.editValue);
  // Modal state
  const [modal_backdrop, setModalBackdrop] = useState(false);
  // Images for modal
  const [imageTable, setImageTable] = useState([]);

  const {
    supplier,
    supplierDropLoading,
    userAccess,
    uploadResult,
    uploading,
    documentResult,
    documentError,
    pageField,
  } = useSelector((state) => ({
    supplier: state.CommonAPI_Reducer.vendorSupplierCustomer,
    supplierDropLoading: state.CommonAPI_Reducer.vendorSupplierCustomerLoading,
    userAccess: state.Login.RoleAccessUpdateData,
    uploading: state.UploadNocReducer.uploading,
    uploadResult: state.UploadNocReducer.uploadResult,
    documentResult: state.UploadNocReducer.documentResult,
    documentError: state.UploadNocReducer.documentError,
    pageField: state.CommonPageFieldReducer.pageField,
  }));

  const { commonPartyDropSelect } = useSelector(
    (state) => state.CommonPartyDropdownReducer
  );

  const fields = {
    Supplier: "",
    language: { value: "mr", label: "Marathi" },
    Month: "",
    UploadMonth: "",
    UploadFile: "",
    Language: "",
    SupplierName: "",
  };

  const [state, setState] = useState(() => initialFiledFunc(fields));
  const values = { ...(state?.values || {}) };
  const fieldLabel = state?.fieldLabel || {};
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
  });

  const [supplierSelectedMonth, setSupplierSelectedMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
  });

  useEffect(() => {
    dispatch(commonPageFieldSuccess(null));
    dispatch(commonPageField(pageId.NOC_DOCUMENT_UPLOAD));

    return () => {
      dispatch(commonPageFieldSuccess(null));
    };
  }, []);

  useEffect(() => {
    if (pageField) {
      const fieldArr = pageField.PageFieldMaster;
      comAddPageFieldFunc({ state, setState, fieldArr });
    }
  }, [pageField]);

  useEffect(() => {
    if (!isShowClicked || documentResult === null) return; // Wait for data

    const statusCode = Number(documentResult?.StatusCode);
    const isSuccess = documentResult?.Status === true;

    if (actionType === "show") {
      if (statusCode === 204 && isSuccess) {
        customAlert({
          Type: 4,
          Message: documentResult?.Message || "No content available.",
        });
        setImageTable([]);
        setModalBackdrop(false);
        setIsShowClicked(false);
        setActionType(null);
        return;
      }

      if (documentError) {
        customAlert({
          Type: 4,
          Message: documentError || "No document found.",
        });
        setImageTable([]);
        setModalBackdrop(false);
        setIsShowClicked(false);
        setActionType(null);
        return;
      }
    }

    if (documentResult?.imageUrl) {
      const isPdf = documentResult.imageUrl.toLowerCase().endsWith(".pdf");

      if (isPdf) {
        window.open(documentResult.imageUrl, "_blank");
        setModalBackdrop(false);
        setImageTable([]);
      } else {
        setImageTable([{ Image: documentResult.imageUrl }]);
        setModalBackdrop(true);
      }

      setIsShowClicked(false);
      setActionType(null);
    }
  }, [documentResult, documentError, isShowClicked, actionType]);

  useEffect(() => {
    let userAcc = null;
    let locationPath = location.pathname;

    if (hasShowModal) {
      locationPath = props.masterPath;
    }

    userAcc = userAccess.find((inx) => {
      return `/${inx.ActualPagePath}` === locationPath;
    });

    if (userAcc) {
      setUserAccState(userAcc);
      breadcrumbReturnFunc({ dispatch, userAcc });
    }
  }, [userAccess, hasShowModal, location.pathname, props.masterPath, dispatch]);

  useEffect(async () => {
    if (uploadResult.Status === true && uploadResult.StatusCode === 200) {
      dispatch(uploadNocDocumentSuccess({ Status: false }));
      setFileAlreadyUploaded(true);

      if (props.pageMode === mode.dropdownAdd) {
        customAlert({
          Type: 1,
          Message: uploadResult.Message,
        });

        const jsonBody = {
          ..._cfunc.loginJsonBody(),
          PartyID: commonPartyDropSelect.value,
        };

        dispatch(filterNocDocument(jsonBody));

        if (props.isOpenModal) {
          props.isOpenModal(false);
        }
      } else {
        let isPermission = await customAlert({
          Type: 1,
          Status: true,
          Message: uploadResult.Message,
        });

        if (isPermission) {
          // Fetch latest list BEFORE redirect
          const [year, month] = selectedMonth.split("-"); // Or get from state if needed

          await dispatch(
            filterNocDocument({
              Supplier: state.values.Supplier?.value,
              PartyID: commonPartyDropSelect.value,
              Month: Number(month),
              Year: Number(year),
            })
          );

          history.push({ pathname: url.NOC_LIST_PAGE });
        }
      }
    } else if (uploadResult.Status === true) {
      dispatch(uploadNocDocumentSuccess({ Status: false }));
      customAlert({
        Type: 4,
        Message: JSON.stringify(uploadResult.Message),
      });
    }
  }, [uploadResult]);

  useEffect(() => {
    if (commonPartyDropSelect.value > 0) {
      dispatch(
        _act.GetVenderSupplierCustomer({
          subPageMode: url.NOC_DOCUMENT_UPLOAD,
          PartyID: commonPartyDropSelect.value,
        })
      );
    } else {
      dispatch(_act.getOrderListPageSuccess([]));
      dispatch(_act.GetVenderSupplierCustomerSuccess([]));
      setState((prev) => ({
        ...prev,
        values: { ...prev.values, Supplier: "" },
        hasValid: { ...prev.hasValid, Supplier: { valid: true } },
      }));
    }
  }, [commonPartyDropSelect, dispatch]);

  useEffect(() => {
    const supplierID = state?.values?.Supplier?.value;
    const partyID = commonPartyDropSelect?.value;
    const [year, month] = selectedMonth.split("-");

    if (supplierID && partyID) {
      const payload = {
        PartyID: partyID,
        Supplier: supplierID,
        Month: month,
        Year: year,
      };
      dispatch(downloadNocDocument(payload));
    }
  }, [
    state?.values?.Supplier?.value,
    selectedMonth,
    commonPartyDropSelect?.value,
    dispatch,
  ]);

  useEffect(() => {
    if (fileAlreadyUploaded) {
      setFileInputDisabled(true);
    } else {
      setFileInputDisabled(false);
    }
  }, [fileAlreadyUploaded]);

  useEffect(() => {
    if (documentResult?.imageUrl) {
      setFileAlreadyUploaded(true);
    } else {
      setFileAlreadyUploaded(false);
    }
  }, [documentResult]);

  useEffect(() => {
    setIsShowClicked(false); // Reset "show" flag when supplier changes
  }, [values?.Supplier?.value]);

  const supplierOptions = supplier.map((i) => ({
    value: i.id,
    label: i.Name,
  }));

  const supplierOnchange = (e) => {
    setState((prev) => ({
      ...prev,
      values: { ...prev.values, Supplier: e },
      hasValid: { ...prev.hasValid, Supplier: { valid: true } },
    }));
  };

  const languageOnchange = (e) => {
    setState((prev) => ({
      ...prev,
      values: { ...prev.values, language: e },
    }));
  };

  const MonthAndYearOnchange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const SupplierMonthAndYearOnchange = (e) => {
    setSupplierSelectedMonth(e.target.value);
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setFileAlreadyUploaded(false);
    }
  };
  const selectedSupplier = state.values.Supplier;

  const handleUpload = () => {
    if (commonPartyDropSelect.value === 0) {
      customAlert({
        Type: 4,
        Message: "Please select Party",
      });
      return;
    }

    if (!selectedSupplier || !selectedSupplier.value) {
      customAlert({
        Type: 4,
        Message: "Please select a Supplier before uploading.",
      });
      return;
    }

    if (!selectedFile) {
      customAlert({
        Type: 4,
        Message: "Please choose a file to upload.",
      });
      return;
    }

    const formData = new FormData();
    const [year, month] = selectedMonth.split("-");

    formData.append("party", commonPartyDropSelect.value);
    formData.append("supplier", selectedSupplier.value);
    formData.append("NOCDocument", selectedFile);
    formData.append("month", month);
    formData.append("year", year);
    formData.append("createdby", _cfunc.loginUserID());
    formData.append("updatedby", _cfunc.loginUserID());
    formData.append("nocfilename", selectedFile.name);

    dispatch(uploadNocDocument({ formData }));
  };

  const handlePDFGeneration = async () => {
    if (!values?.Supplier?.value) {
      customAlert({
        Type: 4,
        Message: "Please select a supplier before generating the PDF.",
      });
      return;
    }
    setReturn_Pdf_loading(true);

    try {
      const [year, month] = supplierSelectedMonth.split("-");

      const jsonBody = {
        PartyID: commonPartyDropSelect.value,
        Supplier: values.Supplier.value,
        Month: month,
        Year: year,
      };
      setActionType("print");
      setIsShowClicked(true);
      dispatch(downloadNocDocument(jsonBody));

      const selectedSupplier = {
        name: values?.Supplier?.label || "Unknown Supplier",
      };

      await PDF_ReturnReport({
        selectedMonth: supplierSelectedMonth,
        Supplier: selectedSupplier,
        LoginDetails: commonPartyDropSelect,
        language: values.language.value,
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setReturn_Pdf_loading(false);
    }
  };

  const baseBtnStyle = {
    minWidth: "120px",
    filter: "brightness(1)",
    transition: "filter 0.3s ease",
  };
  const hoverBtnStyle = {
    filter: "brightness(1.2)",
  };

  const imageShowHandler = () => {
    if (!values?.Supplier?.value || !commonPartyDropSelect?.value) {
      customAlert({
        Type: 4,
        Message: "Please select both Party and Supplier.",
      });
      return;
    }

    const [year, month] = selectedMonth.split("-");

    const requestPayload = {
      PartyID: commonPartyDropSelect.value,
      Supplier: values.Supplier.value,
      Month: Number(month),
      Year: Number(year),
    };
    setActionType("show");
    setIsShowClicked(true);
    dispatch(downloadNocDocument(requestPayload)); // Make sure this sets documentResult.imageUrl
  };

  // Toggle modal
  const tog_backdrop = () => {
    setModalBackdrop(!modal_backdrop);
    if (modal_backdrop) {
      setImageTable([]);
      setIsShowClicked(false);
    }
  };


  return (
    <div className="page-content">
      <Modal
        isOpen={modal_backdrop}
        toggle={tog_backdrop}
        style={{ width: "800px", height: "800px", borderRadius: "50%" }}
        className="modal-dialog-centered"
      >
        {imageTable.length > 0 && <Slidewithcaption Images={imageTable} />}
      </Modal>
      <Container fluid>
        <MetaTags>{metaTagLabel(userPageAccessState)}</MetaTags>
        <Card className="text-black">
          <CardHeader className="card-header text-black c_card_header">
            <h4 className="card-title text-black">
              {userPageAccessState?.PageDescription}
            </h4>
            <p className="card-title-desc text-black">
              {userPageAccessState?.PageDescriptionDetails}
            </p>
          </CardHeader>

          <CardBody className="text-black">
            {/* DOWNLOAD SECTION */}
            <div
              style={{
                backgroundColor: "#e6e6fa",
                padding: "20px",
                borderRadius: "8px",
                marginBottom: "20px",
              }}
            >
              <h5 style={{ marginBottom: "15px" }}>Supplier</h5>
              <Row className="align-items-end">
                <Col lg={3}>
                  <FormGroup className="mb-2">
                    <Label>{fieldLabel.Month}</Label>
                    <Input
                      type="month"
                      className="form-control"
                      value={supplierSelectedMonth}
                      onChange={SupplierMonthAndYearOnchange}
                    />
                  </FormGroup>
                </Col>
                <Col lg={3}>
                  <FormGroup className="mb-2">
                    <Label>{fieldLabel.SupplierName}</Label>
                    <C_Select
                      name="Supplier"
                      classNamePrefix="select2-Customer"
                      value={values.Supplier}
                      options={supplierOptions}
                      onChange={supplierOnchange}
                      isLoading={supplierDropLoading}
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 2 }),
                      }}
                    />
                  </FormGroup>
                </Col>

                <Col lg={3}>
                  <FormGroup className="mb-2">
                    <Label>{fieldLabel.Language}</Label>
                    <C_Select
                      name="language"
                      classNamePrefix="select2-Customer"
                      value={values.language}
                      options={[
                        { value: "mr", label: "Marathi" },
                        { value: "en", label: "English" },
                      ]}
                      onChange={languageOnchange}
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 2 }),
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col lg={3} className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handlePDFGeneration}
                    disabled={Return_Pdf_loading}
                    onMouseEnter={() => setHoveredBtn("download")}
                    onMouseLeave={() => setHoveredBtn("")}
                    style={{
                      ...baseBtnStyle,
                      marginBottom: "10px",
                      ...(hoveredBtn === "download" ? hoverBtnStyle : {}),
                    }}
                  >
                    Print
                  </button>
                </Col>
              </Row>
            </div>

            {/* UPLOAD SECTION */}
            <div
              style={{
                backgroundColor: "#e6e6fa",
                padding: "20px",
                borderRadius: "8px",
              }}
            >
              <h5 style={{ marginBottom: "15px" }}>Upload</h5>
              <Row className="align-items-center">
                <Col lg={3}>
                  <FormGroup className="mb-2">
                    <Label>{fieldLabel.UploadMonth}</Label>
                    <Input
                      type="month"
                      className="form-control"
                      value={selectedMonth}
                      onChange={MonthAndYearOnchange}
                    />
                  </FormGroup>
                </Col>
                <Col lg={4}>
                  <FormGroup className="mb-2">
                    <Label>{fieldLabel.UploadFile}</Label>
                    <Input
                      type="file"
                      className="form-control"
                      accept=".jpg, .jpeg, .png, .pdf"
                      onChange={handleFileChange}
                      ref={fileInputRef}
                      disabled={fileInputDisabled}
                    />
                  </FormGroup>
                </Col>
                <Col lg={5} className="d-flex justify-content-end gap-2">
                  {/* Show Button */}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={imageShowHandler}
                    disabled={
                      !values?.Supplier?.value || !commonPartyDropSelect?.value
                    }
                    onMouseEnter={() => setHoveredBtn("show")}
                    onMouseLeave={() => setHoveredBtn("")}
                    style={{
                      ...baseBtnStyle,
                      marginTop: "23px",
                      ...(hoveredBtn === "show" ? hoverBtnStyle : {}),
                    }}
                  >
                    Show
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleUpload}
                    disabled={uploading || fileAlreadyUploaded}
                    onMouseEnter={() => setHoveredBtn("upload")}
                    onMouseLeave={() => setHoveredBtn("")}
                    style={{
                      ...baseBtnStyle,
                      marginTop: "23px",
                      ...(hoveredBtn === "upload" ? hoverBtnStyle : {}),
                    }}
                  >
                    {uploading ? "Uploading..." : "Upload"}
                  </button>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default NocDocumentUpload;
